import { render, staticRenderFns } from "./BidDefaultCostsDialog.vue?vue&type=template&id=b3671828&"
import script from "./BidDefaultCostsDialog.vue?vue&type=script&lang=js&"
export * from "./BidDefaultCostsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports